import { QuoteType as EnumQuoteType } from '~/__generated__/globalTypes'
import { PROCESSID_IM } from '~/lib/partsConstants'

export const DRAFT = 'draft'
export const REORDERING = 'reordering'
export const REQUESTED = 'requested'
export const OFF_PLATFORM = 'off-platform'
export const REVIEWED = 'reviewed'
export const APPROVED = 'approved'
export const PURCHASED = 'purchased'
export const DELETED = 'deleted'
export const ISPUBLISHED = 'isPublished'
export const QUANTITY_RANGE_UNAVAILABLE = 'QUANTITY_RANGE_UNAVAILABLE'
export const NEEDS_RFQ = 'needs_rfq'
export const PURCHASABLE = 'purchasable'

export type QuoteStatus =
    | typeof DRAFT
    | typeof REORDERING
    | typeof REQUESTED
    | typeof OFF_PLATFORM
    | typeof REVIEWED
    | typeof APPROVED
    | typeof PURCHASED
    | typeof DELETED
    | typeof PURCHASABLE

export function isCustomQuoteLocked(
    quote?: { status: QuoteStatus | string } | null,
) {
    return Boolean(
        quote?.status &&
            quote?.status !== DRAFT &&
            quote?.status !== PURCHASABLE,
    )
}

export const QUOTE_SUMMARY_STATUSES = {
    EMPTY_QUOTE: 'Empty Quote',
    FILES_MISSING_CONFIGURATION: 'File(s) Missing Configuration',
    NEEDS_RFQ_HAS_FAILURES: "Needs to be RFQ'd, Includes Parts with Failures",
    NEEDS_RFQ: 'Needs to be RFQ’d',
    AWAITING_QUOTATION: 'RFQ’d, Waiting for Quote',
    HAS_FAILURES: 'RFQ’d, Includes Parts with Failures',
    PURCHASABLE_WITH_WARNINGS: 'Ready for Purchase - Has Warnings',
    PURCHASABLE: 'Ready for Purchase',
    PURCHASED: 'Purchased',
    UNMATCHED:
        'Current quote state is either unexpected, or does not match the set of conditions that we check for!',
    DELETED: 'Deleted',
}

export const isQuoteTypeIm = (quoteType?: EnumQuoteType) => {
    return Boolean(quoteType && quoteType === EnumQuoteType[PROCESSID_IM])
}
